import {usePermissions} from 'react-admin'

const useIsOwner = () => {
  const {permissions: {allowedRoles = []} = {}} = usePermissions<Permissions>()
  return allowedRoles.includes('merchant_owner')
}

export default useIsOwner
